import { gql } from '@apollo/client'

export const UPDATE_CHATBOT_CONVERSATION_TUNNEL_DRAFT = gql`
  mutation updateChatbotConversationTunnelDraft(
    $id: ID
    $providerId: ID
    $draft: JSON!
    $streamChatMessageId: ID
  ) {
    updateChatbotConversationTunnelDraft(
      id: $id
      providerId: $providerId
      draft: $draft
      streamChatMessageId: $streamChatMessageId
    ) {
      id
      providerId
    }
  }
`
